import { Fragment, useState } from 'react'
import { Button, Card, CardBody, Modal } from 'react-bootstrap'
import { getLabelTipoBilancia } from '../../utils/utils'
import dayjs from 'dayjs'
import 'react-calendar/dist/Calendar.css'
import { useBilanceListInfinite } from '../../hooks/bilance'
import StickyTable from '../../components/StickyTable'

interface ModalConfirmProps {
  isOpen: boolean
  toggle: () => void
  save: (values: any) => Promise<void>
  cliente: number
  bilance: number[]
}

export default function ModalRichiesteDaCalendario({
  isOpen,
  toggle,
  save,
  cliente,
  bilance,
}: ModalConfirmProps) {
  const {
    data: bilanceInfinite,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useBilanceListInfinite({
    cliente: String(cliente),
    data_richiesta__isnull: 'true',
    data_intervento_periodica_aperto__isnull: 'true',
    data_richiesta_periodica__isnull: 'true',
    verif_periodica: 'true',
  })

  const [bilanceSelected, setBilanceSelected] = useState<number[]>(bilance)
  const [dataRichiesta, setDataRichiesta] = useState('')
  const [note, setNote] = useState('')

  return (
    <Modal
      show={isOpen}
      onHide={toggle}
      centered
      size="xl"
      backdropClassName="backdrop-high"
    >
      <Modal.Header className="">
        <Modal.Title>Aggiunta richiesta</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
          minHeight: 'calc(100vh - 200px)',
        }}
      >
        <div className="row mt-4">
          <div className="col-md-8">
            <Card>
              <CardBody>
                <StickyTable
                  isLoading={isLoading}
                  className="StickyInModal"
                  onEndReached={hasNextPage ? fetchNextPage : undefined}
                >
                  <thead className="position-sticky top-0 bg-white border-bottom border-top">
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              setBilanceSelected(
                                bilanceInfinite?.pages
                                  ?.map((pagina) =>
                                    pagina.results.map(
                                      (bilancia) => bilancia.id
                                    )
                                  )
                                  .flat() ?? []
                              )
                            } else {
                              setBilanceSelected([])
                            }
                          }}
                          checked={
                            bilanceSelected.length ===
                            (
                              bilanceInfinite?.pages
                                ?.map((pagina) =>
                                  pagina.results.map((bilancia) => bilancia.id)
                                )
                                .flat() ?? []
                            ).length
                          }
                        />
                      </th>
                      <th>Bilancia</th>
                      <th>Data scadenza</th>
                      <th>Sede</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bilanceInfinite?.pages?.length === 0 && (
                      <tr>
                        <td colSpan={5} className="text-center">
                          Nessuna bilancia disponibile
                        </td>
                      </tr>
                    )}
                    {bilanceInfinite?.pages?.map((pagina, i) => (
                      <Fragment key={i}>
                        {pagina.results.map((bilancia, j) => (
                          <Fragment key={bilancia.id}>
                            <tr>
                              <td className="p-md">
                                <input
                                  type="checkbox"
                                  checked={bilanceSelected.includes(
                                    bilancia.id
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setBilanceSelected([
                                        ...bilanceSelected,
                                        bilancia.id,
                                      ])
                                    } else {
                                      setBilanceSelected(
                                        bilanceSelected.filter(
                                          (id) => id !== bilancia.id
                                        )
                                      )
                                    }
                                  }}
                                />
                              </td>
                              <td>
                                {bilancia.matricola}{' '}
                                {bilancia?.sigla ? `(${bilancia.sigla})` : ''} -{' '}
                                {getLabelTipoBilancia(bilancia.tipo_bilancia)}
                              </td>
                              <td>
                                {bilancia.data_scadenza_taratura
                                  ? dayjs(
                                      bilancia.data_scadenza_taratura
                                    ).format('DD/MM/YYYY')
                                  : '-'}
                              </td>
                              <td className="p-sm">
                                <div>{bilancia.cliente_ragione_sociale}</div>
                                <div>
                                  {bilancia.sede_data?.comune_data?.nome}
                                </div>
                                <div>
                                  {bilancia.sede_data.toponimo_data?.nome}{' '}
                                  {bilancia.sede_data.via}{' '}
                                  {bilancia.sede_data.civico} (
                                  {bilancia.sede_data.provincia_data?.sigla})
                                </div>
                              </td>
                            </tr>
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
                  </tbody>
                </StickyTable>
              </CardBody>
            </Card>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="label-m text-body-secondary">
                Data richiesta
              </label>
              <input
                type="date"
                className="form-control"
                value={dataRichiesta}
                onChange={(e) => setDataRichiesta(e.target.value)}
              />
            </div>
            <div className="form-group mt-4">
              <label className="label-m text-body-secondary">Note</label>
              <textarea
                className="form-control"
                rows={4}
                placeholder="Inserisci note"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button type="button" onClick={toggle} variant="outline-secondary">
          Chiudi
        </Button>
        <Button
          type="button"
          variant="secondary"
          disabled={bilanceSelected.length === 0 || !dataRichiesta}
          className="text-white"
          onClick={() =>
            save({
              bilance: bilanceSelected,
              data_richiesta: dataRichiesta,
              note,
            })
          }
        >
          Salva
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
